import React from "react";

// The chips' tones (also InfoChip's).
export const CHIP_TONES = {
  success:
    "border-state-success-border bg-state-success-bg text-state-success-text",
  info: "border-state-info-border bg-state-info-bg text-state-info-text",
  neutral:
    "border-state-neutral-border bg-state-neutral-bg text-state-neutral-text",
  warning:
    "border-state-warning-border bg-state-warning-bg text-state-warning-text",
  danger:
    "border-state-danger-border bg-state-danger-bg text-state-danger-text",
};

// An item's fulfilment state: label and tone.
export const LINE_STATES = {
  fulfilled: ["Fulfilled", "success"],
  packing: ["Packing", "info"],
  pick: ["To pick", "neutral"],
  attention: ["Attention", "warning"],
  cancelled: ["Cancelled", "danger"],
};

// The small tinted chip the route sheet and pick list use.
const SheetChip = ({ tone, children }) => (
  <span
    className={`inline-flex shrink-0 items-center gap-[3px] whitespace-nowrap rounded-[4px] border-[1px] px-[5px] py-[1px] text-[10px] font-semibold leading-[1.4] ${CHIP_TONES[tone]}`}
  >
    {children}
  </span>
);

export default SheetChip;
